import * as React from 'react';

import { cn } from '@rematter/ui-web';

import { PurchaseOrderRecord } from '../../types/purchaseOrder';
import { LoadsTab } from '../_shared/LoadsTab/LoadsTab';

type Props = {
  purchaseOrder: PurchaseOrderRecord;
  disableAddLoad?: boolean;
  variant?: 'default' | 'embedded';
};

export const PurchaseOrderTabLoads: React.FC<Props> = ({
  purchaseOrder,
  disableAddLoad = false,
  variant = 'default',
}) => (
  <LoadsTab
    className={cn('@PurchaseOrderTabLoads', variant === 'embedded' && 'p-0')}
    purchaseOrderId={purchaseOrder.id}
    entityType="purchaseOrder"
    disableAddLoad={disableAddLoad}
  />
);
